if (!customElements.get("cart-terms")) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector(".js-cart-terms-checkbox");
      this.form = document.getElementById(
        this.cartTermsCheckbox.getAttribute("form")
      );
      this.submitHandler = this.handleSubmit.bind(this);
      this.checkboxClickHandler = this.handleCheckboxClick.bind(this);
      this.entryAddLoading = document.getElementById("entry-add-loading");
      this.checkoutButton = document.querySelector(".checkout-btn");

      // Initialize fetch options here
      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      // Bind event listeners
      this.form.addEventListener("submit", this.submitHandler);
      this.cartTermsCheckbox.addEventListener(
        "change",
        this.checkboxClickHandler
      );
    }

    disconnectedCallback() {
      this.form.removeEventListener("submit", this.submitHandler);
      this.cartTermsCheckbox.removeEventListener(
        "change",
        this.checkboxClickHandler
      );
    }

    handleSubmit(evt) {
      // Only handle form submission logic here
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        alert(theme.strings.cartTermsConfirmation); // eslint-disable-line
      }
    }

    async handleCheckboxClick(evt) {
      evt.preventDefault(); // Prevent the default checkbox behavior

      console.log("this.checkoutButton", this.checkoutButton)

      try {
        this.entryAddLoading.removeAttribute('hidden');
        this.checkoutButton.setAttribute('disabled', true);
        const response = await this.makeApiRequest();

        if (response) {
          // Check the checkbox after a successful API call
          // this.cartTermsCheckbox.checked = true;
        } else {
          alert("Failed to agree to terms. Please try again.");
        }
      } catch (error) {
        console.log(error);
        alert("An error occurred. Please try again.");
      } finally {
        this.entryAddLoading.setAttribute('hidden', true);
        this.checkoutButton.removeAttribute('disabled');
      }

      this.cartTermsCheckbox.checked = evt.target.checked;

    }

    makeApiRequest() {
      const giveawayName = document.getElementById("entries_name").textContent;
      const totalEntries = document.getElementById("entries_count").textContent;

      console.log("giveawayName: ", giveawayName);
      console.log("totalEntries: ", totalEntries);

      this.fetchRequestOpts.body = JSON.stringify({
        attributes: {
          [giveawayName]: totalEntries,
        },
      });

      return fetch(theme.routes.cartUpdate, this.fetchRequestOpts)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .catch((error) => {
          console.error("There was a problem with the fetch operation:", error);
          throw error;
        });
    }
  }

  customElements.define("cart-terms", CartTerms);
}
